import globalConfig from '@utiles/officialStore/globalConfig';

const FLOW_INTERRUPTED_PARAM = 'flowInterrupted';
const FLOW_BREAK_REASON_PARAM = 'flowBreakReason';
const GAME_PAY_SRTL_PREFIXES = ['3295', '3296'];

export const isGamePaySource = () => {
  try {
    if (
      window.globalGetSrtlSource &&
      typeof window.globalGetSrtlSource === 'function'
    ) {
      return GAME_PAY_SRTL_PREFIXES.includes(window.globalGetSrtlSource());
    }
  } catch {
    return false;
  }
  return false;
};

export const isFlowInterrupted = () => {
  return (
    window.flowInterrupted === true ||
    globalConfig.getHrefParam(FLOW_INTERRUPTED_PARAM) === '1'
  );
};

export const getFlowBreakReason = () => {
  return (
    window.flowBreakReason ||
    globalConfig.getHrefParam(FLOW_BREAK_REASON_PARAM) ||
    ''
  );
};

export const getFlowExtra = () => {
  if (!isGamePaySource() || !isFlowInterrupted()) {
    return null;
  }
  return {
    flowInterrupted: true,
    flowBreakReason: getFlowBreakReason(),
  };
};

export const enrichEventWithFlowExtra = (event) => {
  if (!event || typeof event !== 'object') {
    return event;
  }
  const flowExtra = getFlowExtra();
  if (!flowExtra) {
    return event;
  }
  return {
    ...event,
    extra: {
      ...(event.extra || {}),
      ...flowExtra,
    },
  };
};
